import { addBreadcrumb, getCurrentScope } from '@sentry/browser'

const sentryReduxMiddleware = (store: any) => {
    const scope = getCurrentScope()
    scope.addEventProcessor((event) => {
        const state = store.getState()
        return {
            ...event,
            extra: {
                ...event.extra,
                'redux:state': state,
            },
        }
    })

    return (next: any) => (action: any) => {
        addBreadcrumb({
            category: 'redux-action',
            message: action.type,
        })
        return next(action)
    }
}

export default sentryReduxMiddleware
